<div *ngIf="
    identityService.permissions.indexOf('Communication') >= 0 ||
    identityService.permissions.indexOf('Admin') >= 0 ||
    identityService.permissions.indexOf('Super Admin') >= 0 ||
    identityService.permissions.indexOf('Leader') >= 0 ||
    identityService.permissions.indexOf('Birthday') >= 0
  " [class.SmallArabicFont]="globalService.isRTL == true">
  <h2 class="text-center text-primary">
    {{ globalService.Get("COMMUNICATION") }}
  </h2>
  <div class="accordion" id="accordionCommunication">
    <div class="card">
      <div class="card-header" id="headingTwo">
        <h2 class="mb-0">
          <button class="btn btn-block collapsed" type="button" data-toggle="collapse" data-target="#collapseTwo"
            aria-expanded="false" aria-controls="collapseTwo" [disabled]="MessagingFeature == false"
            [class.btn-primary]="ChurchSMS == true" [class.btn-outline-primary]="ChurchSMS == false"
            (click)="setChurchSMS()">
            {{ globalService.Get("TEXT_INDIVIDUALS") }}
          </button>
        </h2>
      </div>
      <div id="collapseTwo" class="collapse" aria-labelledby="headingTwo" data-parent="#accordionCommunication">
        <div class="card-body">
          <div *ngIf="FullContactsList == null">
            <app-contact [ContactsList]="GetContacts()" Transmission="TEXT" [SenderEmail]="identityService.email"
              [SenderName]="
              identityService.firstName.trim() +
              ' ' +
              identityService.lastName.trim()
            "></app-contact>
          </div>
          <div *ngIf="FullContactsList != null">
            <app-contact [FullContactsList]="FullContactsList" Transmission="TEXT" [SenderEmail]="identityService.email"
              [SenderName]="
              identityService.firstName.trim() +
              ' ' +
              identityService.lastName.trim()
            "></app-contact>
          </div>
        </div>
      </div>
    </div>
    <div class="card">
      <div class="card-header" id="headingOne">
        <h2 class="mb-0">
          <button class="btn btn-block collapsed" type="button" data-toggle="collapse" data-target="#collapseOne"
            aria-expanded="false" aria-controls="collapseOne" [class.btn-primary]="ChurchEmail == true"
            [class.btn-outline-primary]="ChurchEmail == false" (click)="setChurchEmail()">
            {{ globalService.Get("EMAIL_INDIVIDUALS") }}
          </button>
        </h2>
      </div>

      <div id="collapseOne" class="collapse" aria-labelledby="headingOne" data-parent="#accordionCommunication">
        <div class="card-body">
          <div *ngIf="FullContactsList == null">
            <app-contact [ContactsList]="GetContacts()" Transmission="EMAIL" [SenderEmail]="identityService.email"
              [SenderName]="
              identityService.firstName.trim() +
              ' ' +
              identityService.lastName.trim()
            "></app-contact>
          </div>
          <div *ngIf="FullContactsList != null">
            <app-contact [FullContactsList]="FullContactsList" Transmission="EMAIL"
              [SenderEmail]="identityService.email" [SenderName]="
              identityService.firstName.trim() +
              ' ' +
              identityService.lastName.trim()
            "></app-contact>
          </div>
        </div>
      </div>
    </div>
    <div class="card">

      <div class="card">
        <div class="card-header" id="headingThree">
          <h2 class="mb-0">
            <button class="btn btn-block collapsed" type="button" data-toggle="collapse" data-target="#collapseThree"
              aria-expanded="false" aria-controls="collapseThree" [class.btn-primary]="ChurchNotification == true"
              [class.btn-outline-primary]="ChurchNotification == false" (click)="setChurchNotification()">
              {{ globalService.Get("PUSH_NOTIFICATION") }}
            </button>
          </h2>
        </div>

        <div id="collapseThree" class="collapse" aria-labelledby="headingThree" data-parent="#accordionCommunication">
          <div class="card-body">
            <div class="card-body">
              <div *ngIf="FullContactsList == null">
                <app-contact [ContactsList]="GetContacts()" Transmission="NOTIFICATION" [SenderEmail]="identityService.email"
                  [SenderName]="
              identityService.firstName.trim() +
              ' ' +
              identityService.lastName.trim()
            "></app-contact>
              </div>
              <div *ngIf="FullContactsList != null">
                <app-contact [FullContactsList]="FullContactsList" Transmission="NOTIFICATION"
                  [SenderEmail]="identityService.email" [SenderName]="
              identityService.firstName.trim() +
              ' ' +
              identityService.lastName.trim()
            "></app-contact>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>